
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import NavBar from "@/components/layout/NavBar";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import FadeInSection from "@/components/ui/FadeInSection";
import { useLanguage } from "@/components/i18n/language-provider";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-grow flex items-center justify-center">
        <div className="container mx-auto px-6 py-20 text-center">
          <FadeInSection>
            <span className="inline-block rounded-full px-3 py-1 text-sm bg-destructive/10 text-destructive font-medium mb-4">
              {t('error.404')}
            </span>
            <h1 className="text-5xl md:text-6xl font-bold mb-6">{t('error.title')}</h1>
            <p className="text-xl text-muted-foreground mb-10 max-w-xl mx-auto">
              {t('error.description')}
            </p>
            <Button 
              size="lg"
              className="px-6 font-medium text-base"
              onClick={() => navigate('/')}
            >
              {t('error.returnHome')}
            </Button>
          </FadeInSection>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
